import React, {cloneElement, useEffect, useRef, useState} from "react";
import {Link, NavLink, useNavigate} from "react-router-dom";
import logo from "../images/home/logoBar.png"
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles/Bar.css"
import Orari from "./Orari";
import ScrollToTopOnMount from "./ScrollToTopOnMount";
import DanzaPacchettixxl from "./danza/DanzaPachettixxl";
import DanzaPacchettiMedia from "./danza/DanzaPacchettiMedia";
import Bar from "./Bar";
import Bar_2 from "./Bar_2";



function Bar_gestione() {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return (
        <div>
            {windowWidth > 1400 ? (
                <Bar />
            ) : (
                <Bar_2 />
            )}
        </div>
    );
}

export default Bar_gestione;
